import { SharedState, useSharedState } from '@trello/shared-state';

export const colorBlindState = new SharedState<boolean>(false);

/**
 * Readonly representation of whether the user has color blind prefs enabled.
 */
export const useIsColorBlind = () => {
  const [isColorBlind] = useSharedState(colorBlindState);
  return isColorBlind;
};
